import Header from "../../components/Header/Header";
import SearchBox from "../../components/SearchBox/SearchBox";
import Hero from "../../components/AdvancedHero/AdvancedHero";
import ListItem from "../../components/ListItem/ListItem";
import Footer from "../../components/Footer/Footer";
import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import { JobListing } from "../../../common/types";
import ServerPagination from "../../components/ServerPagination/ServerPagination";
import { jobsPerPage } from "../../../common/constants";
import { getTagLabel } from "../../../common/helper";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

interface PosloviProps {
    jobs: JobListing[];
    type?: string;
    slug?: string;
    name?: string;
    total: number;
    page: number;
}

export default function Poslovi({
    jobs,
    type,
    slug,
    name,
    page,
    total,
}: PosloviProps) {
    let title = "";
    let description =
        "Poslovi za programere, QA, dizajnere, menadžere i marketing. Sarajevo, Banja Luka, Mostar, Tuzla, Zenica, Doboj, Bijeljina.";

    switch (type) {
        case "city":
            title = `${name} | IT Poslovi | Najveća baza u BiH`;
            break;
        case "tag":
            title = `${getTagLabel(name)} | Poslovi | Najveća baza u BiH`;
            break;
        case "type":
            title = `${name} | IT Poslovi | Najveća baza u BiH`;
            break;
        case "iskustvo":
            title = `${name} | IT Poslovi | Najveća baza u BiH`;
            break;
        default:
            title = "Dzobs.com | IT Poslovi | Najveća baza u BiH";
            break;
    }

    // Ako je prva stranica na ruti /poslovi, setuj canonical na homepage jer je to dupli content
    const router = useRouter();
    const canonical = router.asPath == "/poslovi/1" ? "/" : router.asPath;

    return (
        <div className="relative bg-white">
            <NextSeo
                title={title}
                description={description}
                canonical={`https://www.dzobs.com${canonical}`}
                noindex={page > 1 ? true : false}
                nofollow={false}
                openGraph={{
                    images: [
                        {
                            url: "https://www.dzobs.com/social.png",
                        },
                    ],
                }}
            />
            <Header />
            <Hero type={type} name={name} />
            <SearchBox />
            <div className="relative mt-16 mb-32 max-w-screen-lg mx-auto px-6 lg:px-0">
                {jobs
                    ? jobs.map((job) => <ListItem key={job.id} job={job} />)
                    : "Loading..."}
                {jobs.length === 0 && (
                    <div className="text-center">
                        Huh... izgleda da nemamo rezultata za tu pretragu.{" "}
                        <br />
                        Možda je vrijeme da baciš oko na drugu tehnologiju? ili
                        čak grad :o
                    </div>
                )}
                {jobs.length > 0 && (
                    <ServerPagination
                        activePage={page}
                        perPage={jobsPerPage}
                        total={total}
                    />
                )}
            </div>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
